
/*
 * mkb-framework
 * ============================================================================
 * Module App Init
 * ============================================================================
 * author: mikabo
 * http://www.mikabo.com
 * ============================================================================
 * Copyright (c) 2015, mikabo
 * All rights reserved.
 * ============================================================================
 */

require(['config'], function() {

	require(['domready', 'app', 'app.facade'], function(domReady, app, Facade) {

		function startApp() {

			console.log('%c--------------------------------------------- startApp ---------------------------------------------', 'color:green; background-color:yellow');
			app.facade = new Facade();
			app.facade.init();
		}

		$(document).ready(function () {

			startApp();

		});

	});

});
define("app.init", function(){});
